export const ReturnStep = {
  SELECT_RETURN_ITEMS: 'SELECT_RETURN_ITEMS',
  SELECT_LABEL: 'SELECT_LABEL',
  SELECT_BOX: 'SELECT_BOX',
  DONE: 'DONE'
};
